import activateDidYouMean from '../includes/email-suggestion.js';

const testing = false;

function setLoading(buttons) {
	buttons.button('loading');
	buttons.filter('[data-loading-hidden]').addClass('hidden');
}

function clearLoading(buttons) {
	buttons.button('reset');
	buttons.filter('[data-loading-hidden]').removeClass('hidden');
}

function hideUpsells(form) {
	const formId = form[0].id;
	const upsells = $(`[data-upsell-form="${formId}"]`);
	const visible = upsells.filter(':visible');

	if (visible.length) {
		visible.modal('hide');
	}
}

function cartData(form) {
	const cartInput = form[0].querySelector('[name="cart"]');
	const cart = JSON.parse(cartInput.value);

	return ga4Cart(... cart);
}

async function submitEmailAddress(form) {
	const email = form.find('[name="email"]');
	const formId = form[0].id;
	const buttons = $(`#${formId}-email-submit`);

	if (!email.val()) {
		return;
	}

	setLoading(buttons);

	try {
		const emailCheck = await ajax('emailCheck', { email: email.val() });

		if (emailCheck.hasOwnProperty('did_you_mean')) {
			activateDidYouMean(form, email.val(), emailCheck.did_you_mean);
			hideUpsells(form);
		}

		if (emailCheck.result === false || emailCheck.hasOwnProperty('did_you_mean')) {
			hideUpsells(form);
			return;
		}
	} catch {
		clearLoading(buttons);
		return;
	}

	let response;

	try {
		response = await ajax('leads', {
			form: 'keap_order_step1',
			email: email.val(),
		});
	} catch {
		clearLoading(buttons);
		return;
	}

	clearLoading(buttons);

	if (response.require_login) {
		$("#loginModal").modal('show');
	}

	if (!response.success) {
		return;
	}

	displayCreditCardForm(form, response.cc_form);
}

function displayCreditCardForm(form, html = null) {
	const formId = form[0].id;
	const step1 = document.getElementById(`${formId}-step1`);
	const step2 = document.getElementById(`${formId}-step2`);
	const cc = document.getElementById(`${formId}-cc-form`);

	if (!!step1) {
		step1.classList.add('hidden');
	}

	step2.classList.remove('hidden');

	cc.innerHtml = '';
	cc.insertAdjacentHTML('beforebegin', html);
}

async function loadCreditCardForm(form) {
	try {
		const response = await ajax('loadCreditCardForm');

		displayCreditCardForm(form, response.html);
	} catch(err) {
		
	}
}

async function submitOrder(form, suppressModal = false, upsellType = null, visibleModal = null) {
	let errored = false;

	const formId = form[0].id;
	const data = form.serializeJSON();

	console.log(`starting order submit`, data.Product, data.Plan);

	data.skip_email_check = form.data('skip_email_check');

	if (upsellType === 'upsell-final') {
		data.finalUpsell = true;
	}

	const buttons = form.add(visibleModal).find('.order-submit');
	const upsell = form.data('upsell');

	form.find('input:required, select:required').each(function() {
		if (!errored && this.value == '') {
			errored = true;
			$(this).focus();
		}
	});

	if (errored) {
		alert("Please enter all required fields!");
		return false;
	}

	if (!form.find("[name='terms']").is(':checked')) {
		alert("You must read and agree to the terms and disclaimers!");
		return false;
	}

	// for non-legacy forms, submit over ajax

	console.log(`submitting order`, data.Product, data.Plan);
	
	// do upsell stuff if necessary

	if (upsell && !suppressModal) {
		$('#' + upsell).modal('show');

		return false;
	}

	setLoading(buttons);

	const keapPayments = form[0].querySelector('keap-payment-method');

	const keapPaymentsHandler = ({ origin, data: eventData }) => {
		if (origin !== 'https://payments.keap.page') {
			return;
		}

		window.removeEventListener('message', keapPaymentsHandler);
		
		if (eventData.success) {
			if (testing) {
				setTimeout(function() {
					clearLoading(buttons);
					submitOrderCallback(form, upsellType, visibleModal);
				}, 2000);
		
				return false;
			}

			const submitData = {
				... data,
				card_id: eventData.creditCardId,
			};
		
			ajax('submitOrder', submitData, function(res) {
				clearLoading(buttons);
				submitOrderCallback(form, upsellType, visibleModal);
			}, function(res) {
				clearLoading(buttons);
				hideUpsells(form);
			});
		} else {
			alert('Please verify your payment details and try again.');
		}
	};

	window.addEventListener('message', keapPaymentsHandler);

	keapPayments.submit();

	return false;
}

async function submitOrderCallback(form, upsellType, visibleModal) {
	const finalUpsell = form.data('finalUpsell');

	await gtmEvent('purchase', cartData(form));

	if (visibleModal) {
		visibleModal.data("wassubmited","1")
	}

	if (finalUpsell && upsellType !== 'upsell-final') {
		if (visibleModal) {
			visibleModal.off('hide.bs.modal');
			visibleModal.modal('hide');
		}

		$('#' + finalUpsell).modal('show');
	} else {
		const data = form.serializeJSON();

		window.location = form.attr('action');
	}
}

function upsellReset() {
	$('.upsell-modal-input-reset').each(function() {
		if ($(this).data('original') !== undefined) {
			$(this).val($(this).data('original'));
		}
	});
}

function initOrderForm(formSelector = '#orderForm') {
	const form = $(formSelector);
	const formId = form[0].id;

	const upsells = $(`[data-upsell-form="${formId}"]`);

	if (form.hasClass('order-form-standalone')) {
		gtmEvent('begin_checkout', cartData(form));
	}

	const emailSubmit = document.getElementById(`${formId}-email-submit`);

	if (emailSubmit) {
		emailSubmit.addEventListener('click', async function(e) {
			e.preventDefault();

			await submitEmailAddress(form);
		});
	}

	initOrderModal(form);

	// form.on('change', ":checkbox[name='terms']", function() {
	// 	form.find("input.initials").prop('disabled', !this.checked);
	// });

	form.on('submit', function(e) {
		e.preventDefault();

		submitOrder(form, false, null);
	});

	upsells.on('hide.bs.modal', function(e) {
		upsellReset();
	});

	upsells.find('.upsell-modal-submit').on('click', function(e) {
		e.preventDefault();

		const modal = $(this).closest('.upsell-modal');
		const data = modal.data('upsellInputs');
		const next = modal.data('upsellNext') ? $('#' + modal.data('upsellNext')) : null;
		const type = modal.data('upsellType');

		for (const key of Object.keys(data)) {
			const input = form.find('input[name="' + key + '"]');

			if (input.data('original') === undefined && modal.data('upsellSticky')=== undefined ) {
				input.data('original', input.val());
				input.addClass('upsell-modal-input-reset');
			}

			input.val(data[ key ]);
		}

		if (next) {
			modal.off('hide.bs.modal');
			modal.modal('hide');
			next.modal('show');
		} else {
			submitOrder(form, true, type, modal);
		}
	});

	upsells.find('.upsell-modal-cancel').on('click', function(e) {
		e.preventDefault();

		const modal = $(this).closest('.upsell-modal');
		const type = modal.data('upsellType');

		if (type === 'upsell-final') {
			window.location = form.attr('action');
		} else {
			upsellReset();
			submitOrder(form, true, type, modal);
		}
	});
}

async function initOrderModal(orderForm) {
	const modal = orderForm.closest('.modal');

	if (!modal.length) {
		return;
	}

	modal.modal({ backdrop: 'static' });

	modal.on('show.bs.modal', function(e) {
		if (e.relatedTarget && e.relatedTarget.dataset.plan) {
			const radio = this.querySelector(`[name="Plan"][value="${e.relatedTarget.dataset.plan}"]`);

			if (radio) {
				radio.checked = true;

				$(radio).trigger('input');
			}
		}
	});

	modal.on('shown.bs.modal', function() {
		const form = this;

		$(form).find('[autofocus]').focus();

		gtmEvent('begin_checkout', cartData(orderForm));
	});

	modal.on('hide.bs.modal', function(e) {
		const form = this;
		console.log("close");

		if (!$(form).data("wassubmited")) {
			gtmEvent('cancel_checkout', cartData(orderForm));
		}

		if (modal.data('closeredirect')) {
			e.preventDefault();

			window.location = modal.data('closeredirect');
		}
	});

	if (!orderForm[0].querySelector('keap-payment-method') && !orderForm[0].querySelector('input[type="email"]')) {
		await loadCreditCardForm(orderForm);
	}

	modal.find('.order-form-plan-option-radio').on('input', function() {
		const val = $(this).val();
		const cart = this.dataset.cart;
		const className = `.order-form-plan-item-${val}`;

		modal.find(`.order-form-plan-item:not(${className})`).addClass('hidden');
		modal.find(className).removeClass('hidden');
		modal.find('input[name="cart"]').val(cart);

		const data = ga4Cart(... JSON.parse(cart));

		gtmEvent('select_item', { items: data.items });
	});

	if (modal.data('followup')) {
		const followupModal = $(modal.data('followup'));

		modal.on('hidden.bs.modal', function() {
			followupModal.modal('toggle');
		});

		followupModal.one('show.bs.modal.init', function() {
			initOrderForm(followupModal.find('form'));
		})
	}
}

export default initOrderForm;
